import { render, staticRenderFns } from "./sarea.vue?vue&type=template&id=682daa80"
import script from "./sarea.vue?vue&type=script&lang=js"
export * from "./sarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports